export var uniqueArray = function uniqueArray(input) {
  return Array.from(new Set(input).values());
};